import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { Label, FeedbackMessage, HelpHint } from '../';
import { useFieldMessageVisible } from './FieldMessages';
import st from './FieldControl.module.scss';

interface IFieldControlProps extends HTMLAttributes<HTMLDivElement> {
	/** Наименование поля ( для привязки лэйбла к инпуту ввода ) */
	name: string;
	/** Обязательно для заполнения */
	isRequired?: boolean;
	/** Флаг НЕ валидности поля */
	isInvalid?: boolean;
	/** Флаг, было ли поле тронуто пользователем (для радио-кнопок, выбора пола в формах, к примеру) */
	isTouched?: boolean;
	/** Сообщение валидации */
	errorMsg?: string;
	/** Не фиксированная высота элемента ( TextArea ) */
	notFixedHeight?: boolean;

	/** Подсказка для поля */
	tooltip?: string;
}

/** Компонента для отображения поля ( лэйбл, инпут (в виде пропса) и сообщение о валидации ) */
const FieldControl: FC<IFieldControlProps> = (props) => {
	const {
		name,
		title,
		isRequired = false,
		isInvalid = false,
		isTouched = false,
		errorMsg = '',
		notFixedHeight = false,
		tooltip,
		children,
		className,
		...otherProps
	} = props;

	const classes = classNames(st.field_group, className, {
		[st.fixed]: !notFixedHeight,
	});

	// Текст сообщения показываем не всегда: одинаковые сообщения про
	// незаполненные обязательные поля схлопываются в одно у верхнего поля
	// (см. FieldMessagesProvider). На подсветку самого поля это не влияет
	const isMessageVisible = useFieldMessageVisible(
		name,
		errorMsg,
		isInvalid && isTouched && !!errorMsg
	);

	return (
		<div className={classes} {...otherProps}>
			{(!!title || !!tooltip) && (
				<div className={st.field_group__Header}>
					{title && (
						<Label htmlFor={name} required={isRequired}>
							{title}
						</Label>
					)}
					{!!tooltip && <HelpHint title={tooltip} />}
				</div>
			)}
			{children}
			{isMessageVisible && <FeedbackMessage message={errorMsg} />}
		</div>
	);
};

export default FieldControl;
